
 /*
  *****************************************************************************
  * WARNING: This file is automatically generated.
  * Do not edit this file manually.
  *****************************************************************************
  * 
  * The source file is located at:
  *   /codebuild/output/src994476363/src/vl-app/pages/clinician/appointments.tsx
  */

import { createFileRoute } from '@tanstack/react-router';
// @ts-check
import React from 'react';
import dynamic from 'next/dynamic';
import { useDispatch } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import { Row, Col } from 'antd';
import { useInitialisedStore } from '@hooks/useInitialisedStore';
import { css } from '@emotion/react';
import { useTranslation } from 'react-i18next';
import * as actions from '@actions';
import { AMENDMENT_QUEUE_CODE } from '@components/Documents/AmendmentAppointments';
import Header from '@components/Layouts/Header/Header';

const MAX_AMENDMENTS_BADGE_COUNT = 9;

const PageHead = dynamic(() => import('@components/Layouts/PageHead/PageHead'));
const Tab = dynamic(() => import('@components/UI/Tabs/Tab'));
const ActiveDocuments = dynamic(() => import('@components/Documents/ActiveDocuments'));
const CompleteDocuments = dynamic(() => import('@components/Documents/CompleteDocuments'));
const AmendmentAppointments = dynamic(() => import('@components/Documents/AmendmentAppointments'));

const ClinicianAppointments = () => {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const initialised = useInitialisedStore();

  const { data: amendmentsCount = 0 } = useQuery({
    queryKey: ['clinicianAppointment', 'amendments-count'],
    queryFn: () => dispatch(actions.clinicianCasesQueue({ cr_queue_code: AMENDMENT_QUEUE_CODE, rows: 10, page: 1 })),
    select: (data) => data?.cr_queues?.length ?? 0
  });
  const amendedBadgeCount =
    amendmentsCount > MAX_AMENDMENTS_BADGE_COUNT ? `${MAX_AMENDMENTS_BADGE_COUNT}+` : amendmentsCount;

  if (!initialised) {
    return <p>{t('Initialising ...')}</p>;
  }

  return (
    <>
      <Header pageType="clinician" pageTitle="Appointments" />

      <section className="section-layout">
        <PageHead backText="Appointments" />

        <main className="container" id="page-content">
          <Row gutter={[0, 30]}>
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={24}
              className="app-table"
              css={css`
                .ctb-tab,
                .ctb-tab-active {
                  padding: 15px 20px 15px !important;
                }
                .orange {
                  color: #db6e20;
                }
              `}
            >
              <Tab
                tabNames={['Upcoming', 'Pending', 'Completed', ...(amendmentsCount ? ['Amendments'] : [])]}
                tabBadge={{ Amendments: amendedBadgeCount }}
                tabContent={[
                  <ActiveDocuments key={1} tabKey={1} type="upcoming" />,
                  <ActiveDocuments key={2} tabKey={2} type="pending" />,
                  <CompleteDocuments key={3} tabKey={3} />,
                  ...(amendmentsCount ? [<AmendmentAppointments key={4} />] : [])
                ]}
              />
            </Col>
          </Row>
        </main>
      </section>
    </>
  );
};

export default ClinicianAppointments;
export const Route = createFileRoute('/clinician/appointments')({ component: ClinicianAppointments });
